import { useContext } from 'react';

import { TreeMapOverlayRefContext } from '../contexts/TreeMapOverlayRefContext.js';

export const useTreeMapOverlayRef = () => {
  const context = useContext(TreeMapOverlayRefContext);
  if (!context) {
    throw new Error(
      '"useTreeMapOverlayRef" needs to be used under "TreeMapOverlayRefContext"',
    );
  }
  return context;
};
